// T134 Artefact 2 — renders one or more JSON-LD nodes as a single
// <script type="application/ld+json">. Pure presentational (no data fetching).
import type { JsonLd as JsonLdNode } from "~/lib/seo/jsonld";

/**
 * `<` is escaped to its unicode form so a string value containing "</script>"
 * can never break out of the script element (XSS hardening for embedded JSON-LD).
 */
function serialize(data: JsonLdNode | JsonLdNode[]): string {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}

export function JsonLd({ data }: { data: JsonLdNode | JsonLdNode[] }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: serialize(data) }}
    />
  );
}
